(() => {
  document.addEventListener('moast-cart-add', () => {
    document.dispatchEvent(new Event('cart:refresh'));
    document.querySelectorAll('moast-player').forEach(el => {
      el.open = false;
    });
    requestAnimationFrame(() => {
      document.querySelector('cart-drawer')?.show?.();
    })
  });
})();